module.exports = __webpack_public_path__ + "img/c5202009-3.cc392cd4.jpg";